// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pricehelp[data-v-6821e834]{font-size:13px;color:#666}", ""]);
// Exports
module.exports = exports;
